export default __webpack_public_path__ + "a29ce8f1bc347ccb9fd7a2c89ff3006b.woff";